import 'bootstrap/dist/css/bootstrap.min.css'
import '../../font.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { Container, Row, Col, Form } from 'react-bootstrap'
import { authFetch } from '../Auth/apiClient'
import { useMsal } from '@azure/msal-react';

const BrandEdit = () => {

    const { instance }  = useMsal();
    const navigate = useNavigate();
    const { id, name, link } = useLocation()['state'];
    const [brandName, setBrandName] = useState(name);
    const [brandLink, setBrandLink] = useState(link);
    const [isDeleting, setIsDeleting] = useState(false);

    function handleSubmit(e) {
        e.preventDefault();
        let brandData = {"id": id, "name": brandName, "link": brandLink};
        authFetch(instance, '/api/upsert_brand', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify(brandData),
        }).then(function(res) {
            navigate('/brands');
        }).catch(function(error) {
            alert('There was an error connecting to the database, please refresh the page.');
        });
    }

    function deleteBrand() {
        if (isDeleting) {
            return;
        }

        if (id == null) {
            navigate('/brands');
            return;
        }

        setIsDeleting(true);

        authFetch(instance, '/api/delete_brand', {
            "method": "DELETE",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify({"id": id}),
        }).then(function(res) {
            if (!res.ok) {
                throw new Error(`Delete failed with status ${res.status}`);
            }
            navigate('/brands');
        }).catch(function(error) {
            setIsDeleting(false);
            alert('There was an error deleting the brand, please refresh the page and try again.');
        });
    }

    return (
        <Container>
            <Row className="mb-3">
                <Col lg={4} className="text-start">
                    {name
                        ? <h2>{name}</h2>
                        : <h2>Brands</h2>
                    }
                </Col>
                <Col xs={2} className="text-end align-self-center d-flex justify-content-end offset-6">
                    <button
                        style={{
                            backgroundColor: "#000000",
                            color: "#ffffff",
                            textDecoration: "none",
                            padding: "5px 10px",
                            opacity: isDeleting ? 0.8 : 1,
                        }}
                        onClick={() => deleteBrand()}
                        disabled={isDeleting}
                    >{isDeleting ? 'Deleting...' : 'Delete'}</button>
                </Col>
            </Row>
            <Row>
                <hr></hr>
                <Col lg={9}>
                    <Form>
                        <Form.Group as={Row}>
                            <Form.Label column lg={2} className="d-flex justify-content-start">Brand Name:</Form.Label>
                            <Col>
                                <Form.Control type="text" value={brandName} onChange={e => setBrandName(e.target.value)}/>
                            </Col>
                        </Form.Group>
                        <br></br>
                        <Form.Group as={Row}>
                            <Form.Label column lg={2} className="d-flex justify-content-start">Logo Path:</Form.Label>
                            <Col>
                                <Form.Control type="text" value={brandLink} onChange={e => setBrandLink(e.target.value)}/>
                            </Col>
                        </Form.Group>
                        <br></br>
                        <Col lg={2}>
                            <button type="submit"
                                className="d-flex justify-content-start"
                                style={{backgroundColor: "#a73c21",
                                    color: "#ffffff",
                                    textDecoration: "underline #a73c21",
                                    padding: "5px 10px"}}
                                onClick={handleSubmit}>Submit</button>
                        </Col>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
}
 
export default BrandEdit;